import { create } from 'xmlbuilder2'
import { EthercatDevice } from '/@/shared/entities/EthercatDevice'
import { createMailboxElements } from './helpers'

class Startup {
  private readonly device: EthercatDevice
  private readonly pretty: boolean

  constructor(device: EthercatDevice, pretty: boolean = true) {
    this.device = device
    this.pretty = pretty
  }

  public toXML() {
    const root = create().ele('EtherCATMailbox')
    createMailboxElements(this.device, root)
    return root.end({ prettyPrint: this.pretty })
  }
}

export default Startup
